/**
 * Update a button property for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import {
	ResponsiveBreakpoint,
	updateResponsiveProperty,
} from '../../../common';
import type { ButtonAttributes, ButtonValues } from '../../types';

/**
 * Update a button property for a specific breakpoint
 */
export const updateButtonProperty = < K extends keyof ButtonValues >(
	attributes: ButtonAttributes,
	property: K,
	value: ButtonValues[ K ],
	breakpoint: ResponsiveBreakpoint,
): ButtonAttributes => {
	return updateResponsiveProperty( attributes, property, value, breakpoint );
};
